/**
 * This class registers an event handler to the input type file element if present in the skin. Upon user selecting
 * a file, event handler will create an XHR POST request to send multipart request body to the file transfer server.
 * @module: com.inq.flash.client.control
 * @class: FileUploadHandler
 */
com.inq.flash.client.control.FileUploadHandler = {};

/**
 * Event handler to send multipart request body to the file transfer server
 * @static
 * @public
 * @param {File} file file object
 * @param {Function} uploadHandlerCallback Callback to handle response from file upload API
 */
com.inq.flash.client.control.FileUploadHandler.actionUpload = function (file, uploadHandlerCallback, engagedCallback) {
	if (typeof uploadHandlerCallback !== "function") {
		throw new Error("Expecting a Function");
	}

	/**
	 * converting MB to bytes
	 * @type {number}
	 */
	var fileSize = parseInt(com.inq.flash.client.control.FlashPeer.getFileTransferSize() || "5", 10) * 1000 * 1000;

	/** @type {String} * */
	var agentGroupId = com.inq.flash.client.control.FlashVars.getValue("agID");

	/** @type {String} * */
	var url = com.inq.flash.client.control.FlashPeer.getFileTransferUrl() + "/filetransfer/rest/cont/uploadFile";

	/** @type {String} * */
	var siteId = com.inq.flash.client.control.FlashVars.getValue("siteID");

	if (file) {
		/** @type {XMLHttpRequest} * */
		var xhr;

		/** @type {FormData} * */
		var formData = new FormData();

		/** @type {String}  */
		var fileName = file.name;

		var hasFileExtension = com.inq.flash.client.control.FileUploadHandler.fileExtensionAllowed(fileName);

		if (!hasFileExtension) {
			uploadHandlerCallback({ status: "error", type: "uploadTypeError" });
			return;
		}

		if (file.size > fileSize) {
			uploadHandlerCallback({ status: "error", type: "uploadSizeError" });
			return;
		}

		formData.append("file", file);
		formData.append("siteId", siteId);
		xhr = new XMLHttpRequest();
		xhr.open("POST", url);
		xhr.send(formData);

		xhr.onreadystatechange = function () {
			if (xhr.status === 200 && xhr.readyState === XMLHttpRequest.DONE) {
				/** @type {{fileName: string, responseStatus: number}} */
				var resp = JSON.parse(xhr.response);

				if (resp && resp["responseStatus"] === 200) {
					com.inq.flash.client.control.FileUploadHandler.sendFileURLToAgent(resp, siteId, agentGroupId, engagedCallback);
					uploadHandlerCallback({ status: "success", type: "uploadSuccessText" });
				} else {
					uploadHandlerCallback({ status: "error", type: "unexpectedError" });
				}
			} else if (xhr.status === 400 && xhr.readyState === XMLHttpRequest.DONE) {
				uploadHandlerCallback({ status: "error", type: "uploadBadFile" });
			} else if (xhr.readyState === XMLHttpRequest.DONE) {
				uploadHandlerCallback({ status: "error", type: "uploadServerError" });
			}
		};
	}
};

/**
 * Sends file url to agent.
 * @param {{fileName: string}} response file upload response
 * @param {string} siteId Id for site
 * @param {string} agentGroupId Id for Agent group
 */
com.inq.flash.client.control.FileUploadHandler.sendFileURLToAgent = function (response, siteId, agentGroupId, engagedCallback) {
	/** @type {string} */
	var fileDel = com.inq.flash.client.control.FlashPeer.getFileDeleteSetting() || "ON_CHAT_END";
	var fileTransferUrl = com.inq.flash.client.control.FlashPeer.getFileTransferApiUrl();
	var fileName = response["fileName"];
	var messageString = com.inq.flash.client.control.FileUploadHandler.buildFileURLString(fileTransferUrl, siteId, fileName, agentGroupId);
	com.inq.flash.client.control.ApplicationController.applicationController.sendFileUploadMessage(messageString, fileDel, engagedCallback);
};

/**
 * Creates a file url string to be sent to agent
 * @param {string} fileTransferUrl URL for file Transfer
 * @param {string} siteId Id for Site
 * @param {string} fileName Name of File
 * @param {string} agentGroupId GroupId for Agent
 * @returns {string} URL for File Upload
 */
com.inq.flash.client.control.FileUploadHandler.buildFileURLString = function (fileTransferUrl, siteId, fileName, agentGroupId) {
	return fileTransferUrl + "/chatfiles/" + siteId + "/" + encodeURI(fileName) + "?site=" + siteId + "&agentGroup=" + agentGroupId;
};

/**
 * Check for file Extension to be present in db configuration.site.file_transfer_extensions
 * configured via Portal
 * @param {string} fileName
 * @returns {boolean}
 */
com.inq.flash.client.control.FileUploadHandler.fileExtensionAllowed = function (fileName) {
	/** @type {string} * */
	var fileTransferExtensions = com.inq.flash.client.control.FlashPeer.getfileTransferExtensions();

	var fileExtension = fileName.split(".").reverse()[0];

	var fileNameExtensionList = [];

	if (typeof fileTransferExtensions === "string") {
		fileNameExtensionList = fileTransferExtensions.split(",");
	}

	return fileNameExtensionList.indexOf(fileExtension) !== -1;
};
